import React ,{useState} from "react";
import { ChevronDown, ChevronUp } from "lucide-react"; // Import the Lucide icons

const Heading = ({OverviewData}) => {
  const [readMore, setReadMore] = useState(false);
  const { overviewImage, tagline, description, amenities, buttonmessage, buttonLabel } = OverviewData;

  const handleToggle = () => {
    setReadMore(!readMore);
  };
  return (
    <div className="w-full flex justify-center mt-5">
      <div className="w-full flex gap-14 flex-col sm:w-full md:w-full lg:w-4/5 xl:w-5/6 px-2 md:px-0">
        <div className="mt-2">
          <h2 className=" text-lg md:text-4xl mb-12 text-center  ">{tagline}</h2>

          {/* Section Data  */}

          <div>
            <section className="">
              <div className="about-one__img-two"></div>
              <div className="container">
                <div className=" flex  flex-col justify-between items-center gap-10">
                  <div className="col-xl-6">
                  <div className="">
                          <img src={overviewImage} className=" w-full h-[500px] " alt="description" />
                        </div>
                  </div>
                  <div className="w-full">
                    <div className="about-one__right">
                      {/* <div className="section-title text-left">
                        <h2 className="section-title__title">tagline</h2>
                      </div> */}

                      <div
                         className={`transition-all duration-300 ${readMore ? "h-[300px] overflow-y-auto" : "h-[300px] overflow-hidden"
                         }`}
                         style={{
                           WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS devices
                         }}
     
                      >
                        {description.map((text, index) => (
                          <p key={index} className="about-three__text mb-5 leading-[27px] text-[18px]">
                           {text}
                          </p>
                        ))}
                      
                      </div>
                      <br />
                      {/* {buttonLabel && (
                        
                      )} */}
                      <div className="cta-two__btn-box">
                          <button
                            className=" bg-[--alipes-base] flex items-center gap-2 w-[200px] py-2 px-10  text-white text-lg"
                            onClick={handleToggle}
                          >
                            {readMore ? (
                              <> 
                                Read Less <ChevronUp className="w-4 h-4" />
                              </>
                            ) : (
                              <>
                                Read More <ChevronDown className="w-4 h-4" />
                              </>
                            )}
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Heading;
